module.exports = __webpack_public_path__ + "img/product3.27e31c57.png";